/* eslint-disable no-undef */
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { CompleteUserWellnessTask } from "../../../redux/constants/apiConstants";
import {feelingsData} from "../../../../mockData";
import { FeelingCard } from "./styles";
import { CommonButtonPopup } from "../../ReportsV2/styles";
import { Border } from "../../Journeys/styles";
import {  StyledModal } from "../../AttendeesModal/styles";
import { fetchApi } from "../../../utils/methods";
import { CustomTitle } from "../../UserDashboard/styles";
import { useHistory } from 'react-router-dom';


const FeelingModal = ({ showModal, onHide, challengeId, taskId,  completedStatus, setActiveTab }) => {
  const [selectedFeeling, setSelectedFeeling] = useState(null);
  const history = useHistory();

  const handleSubmit = async () => {
    if (!selectedFeeling) {
      toast.error("Please select a feeling first!");
      return;
    }

    try {
      const payload = {
        challenge_id: Number(challengeId),
        task_id: Number(taskId),
        completed_status: completedStatus,
        feeling: selectedFeeling,
      };

      const res = await fetchApi(CompleteUserWellnessTask, "POST", payload);

      if (res?.status === "success") {
        toast.success(res?.data?.message || "Feeling saved!");
        onHide();
        if(setActiveTab)
          setActiveTab("Journal");
        else
          history.push(`/challenges/wellness-challenge/${challengeId}`);
      } else {
        toast.error(res?.data?.message || "Failed to save feeling");
      }
    } catch (error) {
      console.error("Error submitting feeling:", error);
    }
  };

  return (
    <StyledModal $width={"400px"} $height={"212px !important"} show={showModal}>
      {/* Header */}
      <Modal.Header style={{ background: "white", border: "none" }}>
        <CustomTitle>
          <div className="headerContainer">
            <span className="title" style={{textAlign:"center"}}>{("How are you feeling today?")}</span>
          </div>
        </CustomTitle>
      </Modal.Header>

      <Border
        style={{
          width: "93%",
          background: "#EFEFEF",
          margin: "4px 16px 16px 16px",
        }}
      />

      {/* Body */}
      <Modal.Body
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "4px",
          padding:"0"
        }}
      >
        {feelingsData?.map((f) => (
          <FeelingCard
            key={f.id}
            className={selectedFeeling === f.id ? "active" : ""}
            onClick={() => setSelectedFeeling(f.id)}
          >
            <div className="emoji"><span style={{height:'24px'}}>{f.emoji}</span></div>
            <div className="label">{f.label}</div>
          </FeelingCard>

        ))}
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer
        style={{
          borderTop: "none",
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <CommonButtonPopup
          height="40px"
          width="82px"
          onClick={selectedFeeling ? handleSubmit : null}
          disabled={!selectedFeeling}
        >
          {("Submit")}
        </CommonButtonPopup>
      </Modal.Footer>
    </StyledModal>
    
  );
};

FeelingModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  challengeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  taskId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  completedStatus:PropTypes.bool
};

export default withTranslation()(FeelingModal);
